import { fetchV1Units, createV1Unit } from "@/services/v1/inventoryAPIService";

export default {
  state: {
    units: [],
    unitPageSize: 5,
    totalUnitCount: 0,
  },
  getters: {
    units: (state) => state.units,
    currentUnitPageSize: (state) => state.unitPageSize,
    totalUnitCount: (state) => state.totalUnitCount,
  },
  mutations: {
    SET_UNITS(state, units) {
      state.units = units;
    },
    SET_UNIT_PAGE_SIZE(state, pageSize) {
      state.unitPageSize = pageSize;
    },
    SET_TOTAL_UNITS_COUNT(state, count) {
      state.totalUnitCount = count;
    },
  },
  actions: {
    async fetchUnits({ commit }, { page = 1, pageSize = 5 } = {}) {
      //   commit("SET_LOADING", true);
      try {
        const response = await fetchV1Units(page, pageSize);
        commit("SET_UNITS", response.results);
        commit("SET_UNIT_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_UNITS_COUNT", response.count);
      } catch (error) {
        console.error("Error fetching units:", error);
      } finally {
        // commit("SET_LOADING", false);
        console.log("finally...");
      }
    },
    async addUnit({ commit }, unit) {
      try {
        const response = await createV1Unit(unit);
        if (response.error) {
          const errorMessages = [];
          errorMessages.push(response.message);
          // commit("SET_ERROR", errorMessages);
          return { success: false, message: response.message };
        }
        return { success: true, data: response };
      } catch (error) {
        const errorMessages = [];
        for (const [key, value] of Object.entries(error.response.data)) {
          errorMessages.push(value[0]);
          console.log(`unit create... ${key}: ${value}`);
        }
        commit("SET_ERROR", errorMessages);
        const message =
          error.response?.data?.message || "Failed to add Unit.";
        return { success: false, message };
      }
    },
  },
};
